import { Component, inject, input, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import {
  BaseRepublishDto,
  CoinTransactionState,
  CompositeTransactionDto,
  ITransactionState,
  LogDto
} from '@coin/importer/dto/util';
import { environment } from '@coin/shared/core/util-environments';
import { Subscription, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LogsService } from '../../services/logs/logs.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'importer-transaction-state-progress-bar',
  templateUrl: './transaction-state-progress-bar.component.html',
  styleUrls: ['./transaction-state-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TransactionStateProgressBarComponent {
  private logsService = inject(LogsService);

  public readonly data = input<LogDto | BaseRepublishDto>(undefined);

  public compositeTransaction: CompositeTransactionDto;
  public transactionStates: ITransactionState[];

  transactionStateSubscription: Subscription;

  public mode: 'determinate' | 'indeterminate' = 'indeterminate';
  public percentage = 100;
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.subscribeTransactionStateUpdates();
  }

  subscribeTransactionStateUpdates(): void {
    this.transactionStateSubscription = interval(environment.subscriptionIntervalInMs)
      .pipe(
        switchMap(() => this.logsService.getCompositeTransactionById(this.data().id)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(result => {
        if (result) {
          const coiniTransactionState = result.SubTransactions.filter(transaction =>
            transaction.transactionId.endsWith(this.data().id)
          ).pop();
          this.transactionStates = result.SubTransactions;
          if (coiniTransactionState.state !== CoinTransactionState.Started) {
            this.mode = 'determinate';
          }
        }
      });
  }

  calculateTransactionProcessPercentage(transactionState: ITransactionState): number {
    if (transactionState) {
      if (transactionState.progressCount && transactionState.totalCount) {
        return (transactionState.progressCount / transactionState.totalCount) * 100;
      }
    }
    return 0;
  }
}
